/* eslint-disable max-lines-per-function */

import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@e2n/ui/v2';

import { AvatarBox } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/AvatarBox';
import { FristenActions } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/FristenTable/FristenActions';
import { FristenComment } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/FristenTable/FristenComment';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { FristenGrund } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/fristenGrund';
import { cn } from '@/lib/utils';
import dayjs from 'dayjs';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

export function FristenTable({ readonly = false }: { readonly?: boolean }) {
  const form = useAnlageassistentFormContext();
  const { t } = useTranslation();

  return (
    <form.Subscribe
      selector={(state) => state.values.anstellungsverhaeltnis.fristen}>
      {(fristen) =>
        fristen.length > 0 && (
          <div className="hidden md:flex w-full">
            <Table>
              <TableHeader>
                <TableHead>
                  {t(
                    'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.fristdatum.label',
                  )}
                </TableHead>
                <TableHead>
                  {t(
                    'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.grund.label',
                  )}
                </TableHead>
                <TableHead>
                  {t('domain.mitarbeiter.fristen.erinnerungsZeit.label')}
                </TableHead>
                <TableHead>
                  {t(
                    'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.erinnerungAn.label',
                  )}
                </TableHead>
                <TableHead></TableHead>
              </TableHeader>
              <TableBody>
                {fristen.map((frist, index) => (
                  <TableRow key={index}>
                    <TableCell
                      type="text"
                      text={dayjs(frist.fristdatum).format('DD.MM.YYYY')}
                      className="py-5"
                    />
                    <TableCell
                      type="text"
                      text={
                        frist.grund === FristenGrund.ANDERER
                          ? frist.andererGrund
                          : t(
                              `domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.grund.options.${frist.grund}`,
                            )
                      }
                    />
                    <TableCell
                      type="text"
                      text={frist.erinnerungsZeit
                        .map((zeit) =>
                          t(
                            `domain.mitarbeiter.fristen.erinnerungsZeit.options.${zeit}`,
                          ),
                        )
                        .join(', ')}
                    />

                    <TableCell type="avatar-group">
                      {frist.erinnerungAn.length > 0 && (
                        <Suspense
                          fallback={<Skeleton className="h-8 w-full" />}>
                          <AvatarBox managerIds={frist.erinnerungAn} />
                        </Suspense>
                      )}
                    </TableCell>
                    <TableCell type="actions">
                      <div className="flex items-center gap-1">
                        {frist.bemerkung && (
                          <FristenComment bemerkung={frist.bemerkung} />
                        )}
                        <FristenActions
                          index={index}
                          className={cn(readonly && 'hidden', 'ml-auto')}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )
      }
    </form.Subscribe>
  );
}
